<template>
  <header role="banner">
    <!-- 일반 헤더 -->
    <div v-if="!isPooqzone" :class="[`header`, {'tag-layer-open' : isTagLayerOpen}]">
      <util-menu />
      <gnb :key="$route.fullPath"/>
    </div>

    <!-- 웨이브온 헤더 -->
    <div v-else :class="['header', 'hd-pooqzone', {'tag-layer-open' : isTagLayerOpen}]">
      <pooq-zone-util-menu :agencyname="agencyname"/>
      <pooq-zone-gnb :isplayymovie="isplayymovie" :key="$route.fullPath"/>
    </div>
    <slot/>
  </header>
</template>

<script>
import Gnb from './header/Gnb'
import UtilMenu from './header/UtilMenu'
import PooqZoneGnb from './header/PooqZoneGnb'
import PooqZoneUtilMenu from './header/PooqZoneUtilMenu'
import cookie from '@/common/utils/cookie'
import { SEARCH_HEADER_TAG_LAYER } from '@/common/resources/const'

export default {
  components: {
    Gnb,
    UtilMenu,
    PooqZoneGnb,
    PooqZoneUtilMenu
  },
  data () {
    return {
      isPooqzone: cookie.isWavveOn(),
      pooqzoneInfo: cookie.getPooqZoneInfo(),
      agencyname: '',
      isplayymovie: 'y',
      selectedIndex: 0,
      isTagLayerOpen: false
    }
  },
  methods: {},
  created () {
    if (this.pooqzoneInfo && this.pooqzoneInfo.isPooqzone) {
      // 업체명
      this.agencyname = this.pooqzoneInfo.agencyname
      this.isplayymovie = this.pooqzoneInfo.isplayymovie
    }
  },
  mounted () {
    this.$events.$on(SEARCH_HEADER_TAG_LAYER, ({ isTagLayerOpen }) => { this.isTagLayerOpen = isTagLayerOpen })
  },
  beforeDestroy () {
    this.$events.$off(SEARCH_HEADER_TAG_LAYER)
  }
}
</script>
